import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  Select,
  MenuItem,
  Container,
  Modal,
} from "@mui/material";
import useHeaderStyles from "../testStyle/iitStyle/headerStyle";
import { useProfile } from "../../../context/ProfileContext";
import { decryptData } from "../../../crypto";
import TimerComponent from "../../../components/TimerComponent";
import { useLanguages } from "../../../context/LanguagesContext";
import { useQuestionSection } from "../../../hooks/iit/useQuestionSection";
import { QuestionPalette } from "../default/QuestionPalette";
import clientlogo from '../../../images/clientlogo/ClientLogo.png'
const Header = ({
  subjectNames,
  currentSubject,
  setCurrentQuestion,
  questionData,
  currentQuestion,
  subjectId,
}) => {
  const classes = useHeaderStyles();
  const { profile } = useProfile();
  const { languages, handleChange, selectedLanguage } = useLanguages();

  const [openInstructionsModal, setOpenInstructionsModal] = useState(false);
  const [examName, setExamName] = useState("");
const storedLogo = sessionStorage.getItem("client_logo");
const clogo = !storedLogo || storedLogo === "null" ? clientlogo : storedLogo;
  const {
    setIsTimeUp,
    fetchData,
    showSubmitModal,
    handleCloseSubmitModal,
    handleFinalSubmit,
    isTimeUp,
    stats,
    submitError,
    countdownTime,
    finalSubmitChecked,
    handleFinalSubmitCheck,
  } = useQuestionSection({
    questionData,
    currentQuestion,
    setCurrentQuestion,
    subjectId,
  });

  const handleToggleInstructionModal = () => {
    setOpenInstructionsModal(!openInstructionsModal);
  };

  useEffect(() => {
    try {
      const stored = sessionStorage.getItem("exam_name");
      if (stored) {
        const decrypted = decryptData(stored);
        setExamName(decrypted || "");
      }
    } catch (err) {
      console.error("Error decrypting exam name:", err);
      setExamName("");
    }
  }, []);
  const handleQuestionChange = (index) => {
    setCurrentQuestion(index);
  };

  return (
    <div>
      <AppBar position="static" color="transparent" elevation={0}>
        <Toolbar className={classes.headerToolbar}>
          <Container className={classes.navbarContainer}>
            <Typography
              sx={{
                display: { xs: "none", sm: "block" },
              }}
              className={classes.headerLogo}
            >
              
                <img
                  src={clogo}
                  style={{maxWidth:200,maxHeight:80}}
                  alt="CLIENT LOGO"
                />
             
            </Typography>

            <Typography
              sx={{
                display: { xs: "block", sm: "none" },
              }}
              className={classes.headerLogo}
            >
              CLIENT LOGO
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                gap: 2,
                width: { xs: "100%", sm: "50%" },
              }}
            >
              <div className={classes.profileImagecontainer}>
                <img
                  src={profile?.image_url}
                  alt="Profile IMG"
                  className={classes.profileImage}

                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = "userAvatar.png";
                  }}
                />
              </div>
              <Box className={classes.headerCandidateInfo}>
                <Typography variant="body2">
                  Candidate Name:{" "}
                  <span style={{ color: "#f7931e", fontWeight: "bold" }}>
                    {profile?.full_name || "N/A"}
                  </span>
                </Typography>
                <Typography variant="body2">
                  Subject Name:{" "}
                  <span style={{ color: "#f7931e", fontWeight: "bold" }}>
                    {/* {examName || "N/A"} */}
                    PHYSICS
                  </span>
                </Typography>
                <Typography variant="body2">
                  Time Left:{" "}
                  <span className={classes.candidateTime}>
                    <TimerComponent
                      setIsTimeUp={setIsTimeUp}
                      showSubmitModal={showSubmitModal}
                      handleCloseSubmitModal={handleCloseSubmitModal}
                      handleFinalSubmit={handleFinalSubmit}
                      isTimeUp={isTimeUp}
                      stats={stats}
                      submitError={submitError}
                      countdownTime={countdownTime}
                      finalSubmitChecked={finalSubmitChecked}
                      onFinalSubmitCheck={handleFinalSubmitCheck}
                    />
                  </span>
                </Typography>
              </Box>
            </Box>
          </Container>
        </Toolbar>
      </AppBar>

      {/* Navigation */}
      <Box className={classes.navbar}>
        <Container>
          <Typography
            variant="h6"
            sx={{
              color: "white",
              fontWeight: "bold",
              fontSize: "16px",
              paddingLeft: "10px",
              "@media (min-width: 800px) and (max-width: 898px)": {
                fontSize: "12px",
              },
            }}
          >
            {examName || "N/A"}
          </Typography>
        </Container>
        <Container
          style={{ alignItems: "end", paddingTop: "10px" }}
          className={classes.navbarContainer}
        >
          <Box className={classes.navbarLeft}>
            {/* <Box className={classes.navbarLeft}>
            <Typography
            variant="h6"
            sx={{ color: "white", fontWeight: "bold",fontSize:'16px' }}
            >
            {examName || "N/A"}
            </Typography>
            
            {subjectNames?.map((subjectName, index) => (
              <Button
                key={index}
                onClick={() => setCurrentQuestion(currentSubject[index])}
                className={classes.navbarButton}
                variant="contained"
                >
                {subjectName}
                </Button>
                ))}
                </Box> */}
            <QuestionPalette
              subjectNames={subjectNames}
              currentQuestion={currentQuestion}
              handleQuestionChange={handleQuestionChange}
              classes={classes}
              currentSubject={currentSubject}
              fetchData={fetchData}
            />
          </Box>
          <Box
            className={classes.navbarLanguage}
            sx={{ display: "flex", alignItems: "end" }}
          >
            <Button
              variant="contained"
              className={classes.transparentbtn}
              onClick={handleToggleInstructionModal}
            >
              Instruction
            </Button>
            <Box
              className={classes.navbarLanguage}
              sx={{ mt: { xs: 0, md: 0 } }}
            >
              {/* <Typography className={classes.navbarLanguageText}>
                Paper Language:
              </Typography> */}
              <Select
                value={selectedLanguage}
                onChange={handleChange}
                size="small"
                sx={{
                  backgroundColor: "white",
                  width: "100%",
                  fontSize: "13px",
                  "& .MuiSelect-select": {
                    paddingTop: "5px !important",
                    paddingBottom: "5px !important",
                  },
                }}
              >
                {languages?.map((l, index) => (
                  <MenuItem key={l.value || index} value={l.value}>
                    {l.label}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Box>
        </Container>
      </Box>
      <Modal
        open={openInstructionsModal}
        onClose={handleToggleInstructionModal}
        className={classes.modal}
      >
        <div className={classes.modalContainer}>
          <div className={classes.modalHeader}>
            <Typography className={classes.modalTitle} variant="h4">
              Instructions
            </Typography>
            <Button
              className={classes.modalButton}
              onClick={handleToggleInstructionModal}
            >
              X
            </Button>
          </div>
          <div className={classes.modalContent}>
            <div
              dangerouslySetInnerHTML={{
                __html:
                  selectedLanguage === "english"
                    ? decryptData(sessionStorage.getItem("examInstructions"))
                    : decryptData(sessionStorage.getItem("instructionsHindi")),
              }}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Header;
